<template>
  <div class="relative">
    <ChatSvg/>
    <span
        v-if="unreadMessages.hasUnread"
        class="notification-badge"
    >
<!--      {{ unreadMessages.count > 9 ? '9+' : unreadMessages.count }}-->
      {{ unreadMessages.count }}
    </span>
  </div>
</template>

<script setup>
import ChatSvg from '@/core/components/svg_components/ChatSvg.vue';
import {useUnreadMessagesStore} from "@/modules/profile/store/unreadMessagesStore.js";

const unreadMessages = useUnreadMessagesStore();
</script>

<style scoped>
</style>
